module.exports = __webpack_public_path__ + "static/media/hack.af8eae2f.svg";